import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerMastermindTranslations } from "./i18n";
import {
  applyVerdict,
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
} from "./progress";
import { emptySolution, type MastermindSolution } from "./solution";
import type { MastermindDefinition, MastermindProgress, MastermindSubmission } from "./types";

registerMastermindTranslations(i18n);

/**
 * No `localFeedback`: nothing can be said of a guess without the code, which stays on the
 * server. `applyVerdict` makes the key pegs of each guess part of the autosaved history
 * (ADR 0041, 0055).
 */
export const mastermindModule: PuzzleTypeModule<
  MastermindDefinition,
  MastermindSubmission,
  MastermindProgress,
  MastermindSolution
> = {
  key: "mastermind",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  applyVerdict,
};
